/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@compiled/react';

import { NavEmptyState } from '@atlassian/navigation-common/ui/nav-empty-state';

import type { EmptyStateProps } from './types';

/**
 * TODO: Add proper fallback UI for the ribbon
 * https://hello.jira.atlassian.cloud/browse/NAVX-4203
 */
export const ErrorState = ({ header, description }: EmptyStateProps): JSX.Element => {
	return <NavEmptyState header={header} description={description} />;
};
